<Panel maxw="48" mx="auto" p="xl" border="3" rounded="xs" shadow="xl">

  <ReportDefCreateForm 
    bind:rpt={rpt} 
    />
      
  {#if rpt.builder === 'xls-builder'}
    <Panel mt="sm">
      <XlsBuilderForm 
        bind:rpt={rpt}
        />
    </Panel>
  {/if}

</Panel>

<script>
  import { onMount, tick, createEventDispatcher } from 'svelte'
  import { Panel } from 'svelte-stylo'
  import { TextField, NotesField, SelectField } from 'svelte-stylo-kit'
  import API from '@/api'
  import { cloned, randid } from '@/helpers'
  import ReportDefCreateForm from './ReportDefCreateForm.svelte'
  import XlsBuilderForm from './XlsBuilderForm.svelte'

  export let 
    rpt;

  let 
    emit = createEventDispatcher();
</script>
